{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/separator';

export const section = 'Hooks';
export const description = 'Provides the accessibility implementation for a separator.';
export const isSubpage = true;

# useSeparator

<PageDescription>{docs.exports.useSeparator.description}</PageDescription>

```tsx render files={["starters/hooks/src/Separator.tsx", "starters/hooks/src/Separator.css"]}
"use client";
import {Separator} from 'hooks-starter/Separator';

<div style={{color: 'var(--text-color)'}}>
  <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center', gap: 8}}>
    Content above
    <Separator />
    Content below
  </div>
  <div style={{display: 'flex', flexDirection: 'row', marginTop: 16, height: 40, alignItems: 'center', gap: 8}}>
    Content left
    <Separator orientation="vertical" />
    Content right
  </div>
</div>
```

## API

<FunctionAPI function={docs.exports.useSeparator} links={docs.links} />

### SeparatorProps

<InterfaceType {...docs.exports.SeparatorProps} />

### SeparatorAria

<InterfaceType {...docs.exports.SeparatorAria} />
